import React, { useState, useEffect } from "react";
import { Box, Button, TextField, useTheme, Dialog, DialogActions, DialogContent, DialogTitle, Typography,Snackbar,Alert } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import Header from "components/Header";
import axios from "axios";
 
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
const Customers = () => {
  const theme = useTheme();
  const apiUrl = process.env.REACT_APP_API_URL;   
  const [data, setData] = useState([]); 
  const [isLoading, setIsLoading] = useState(true);
  const [imagePath, setImagePath] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  // State for the form inputs
  const [title, setTitle] = useState("");
  const [number, setNumber] = useState("");
  const [image, setImage] = useState(null);
  const [openModal, setOpenModal] = useState(false);
  const [currentService, setCurrentService] = useState(null); // For update functionality

  // Fetch data from API
  useEffect(() => {
   
    fetchData();
  }, []);
  const fetchData = async () => {
    try {
      const response = await axios.get(`${apiUrl}/progress/getprogress`);
      setData(response.data);
      setIsLoading(false);
    } catch (error) {
      console.error("Error fetching data:", error);
      setIsLoading(false);
    }  
  };
  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };
   
  const handleFileChangeProcess = (event) => {
    const selectedImage = event.target.files[0];
    if (selectedImage) {
      handleImageUpload(selectedImage, setImagePath); // Automatically upload the image
    }
  };
  const handleImageUpload = async (file, setImagePath) => {
    const formData = new FormData();
    formData.append("image", file);

    try {
      const response = await axios.post(`${apiUrl}/upload`, formData);
      console.log("this is image path>>:", response.data.filePath);
      // setImagePath(response.data.filePath); // Assuming the backend returns the image path
      setImagePath(response.data.url);
    } catch (error) {
      console.error("Error uploading image:", error);
      setErrorMessage("Error uploading image.");
      setSnackbarOpen(true);
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!title || !number|!imagePath) {
      setErrorMessage("Please fill all the required fields.");
      setSnackbarOpen(true);
      return;
    }
    const formData = {
      title,
      number,
      images: imagePath
    }

    try {
      const response = await axios.post(`${apiUrl}/progress/createprogress`, formData);

      // Append new data to the existing data
      setData((prevData) => [...prevData, response.data]);
      handleCloseModal();
    } catch (error) {
      console.error("Error submitting form:", error);
    }
  };

  const handleOpenUpdateModal = (service) => {
    setCurrentService(service);
    setTitle(service.title);
    setNumber(service.number);
    setImagePath(service.images)
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
    setTitle("");
    setNumber("");
    setImagePath("")
    setCurrentService(null);
  };

  const handleUpdate = async (event) => {
    event.preventDefault();
    if (!title || !number|!imagePath) {
      setErrorMessage("Title,number and image are required.");
      setSnackbarOpen(true);
      return;
    }
    const formData = {
      title,
      number,
      images: imagePath
    }
    try {
      const response = await axios.put(`${apiUrl}/progress/updateprogress/${currentService._id}`, formData);

      // Update the local state
      setData((prevData) =>
        prevData.map(service =>
          service._id === currentService._id ? response.data : service
        )
      );

      handleCloseModal();
    } catch (error) {
      console.error("Error updating service:", error);
    }
  };

  const handleDelete = async (id) => {
    try {
      await axios.delete(`${apiUrl}/progress/deleteprogress/${id}`);
      setData((prevData) => prevData.filter(service => service._id !== id));
    } catch (error) {
      console.error("Error deleting service:", error);
    }
  };

  const columns = [
     
    { field: "title", headerName: "Title", flex: 0.5 },
    { field: "number", headerName: "Number", flex: 0.5 },
    {
      field: "image",
      headerName: "Image",
      flex: 0.5,
      renderCell: (params) => (
        // <img src={`${apiUrl}/${params.row.images}`} alt={params.row.title} width="50" height="50" />
        <img
          src={params.row.images}
          alt={params.row.title}
          width="50"
          height="50"
        />
      ),
    },
    {
      field: "actions",
      headerName: "Actions",
      flex: 0.5,
      renderCell: (params) => (
        <>
          <Button variant="contained"  style={{marginRight: 8}} color="primary" size="small" onClick={() => handleOpenUpdateModal(params.row)}>
            Update
          </Button>
          <Button variant="contained" color="secondary" size="small" onClick={() => handleDelete(params.row._id)}>
            Delete
          </Button>
        </>
      ),
    },
  ];
  console.log("set image path is this corret:", imagePath)
  return (
    <Box m="1.5rem 2.5rem">
      <Header title="PROGRESS" subtitle="List of Progress" />
      <Button variant="contained" color="primary" onClick={() => setOpenModal(true)}>
        Add New Entry
      </Button>

      <Dialog open={openModal} onClose={handleCloseModal}>
        <DialogTitle>{currentService ? "Update Entry" : "Add New Entry"}</DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            margin="dense"
            label="Title"
            type="text"
            fullWidth
            variant="outlined"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
          />
          <TextField
            margin="dense"
            label="Number"
            type="number"
            fullWidth
            variant="outlined"
            value={number}
            onChange={(e) => setNumber(e.target.value)}
            InputProps={{ className: 'no-spinner' }}
          />
          <Button
            variant="outlined"
            component="label"
            startIcon={<CloudUploadIcon />}
          >
            Upload Image
            <input
              type="file"
              hidden
              onChange={handleFileChangeProcess} // Store the file object instead
            />
          </Button>
          {imagePath && (
            <Typography variant="body2" sx={{ mt: 1 }}>
              {/* <img src={`${apiUrl}/${imagePath}`} alt="image" width="50" height="50" /> */}
              <img src={imagePath} alt="image" width="50" height="50" />
            </Typography>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseModal} color="primary">
            Cancel
          </Button>
          <Button onClick={currentService ? handleUpdate : handleSubmit} color="primary">
            {currentService ? "Update" : "Add"}
          </Button>
        </DialogActions>
      </Dialog>

      <Box mt="40px" height="75vh">
        <DataGrid
          loading={isLoading}
          getRowId={(row) => row._id}
          rows={data || []}
          columns={columns}
          pageSize={5}
        />
      </Box>
      <Snackbar open={snackbarOpen} autoHideDuration={6000} onClose={handleSnackbarClose}>
        <Alert onClose={handleSnackbarClose} severity="error">
          {errorMessage}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default Customers;
